import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider,
    ISearchProviderField,
    ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";


const vUI_Approval_Search_Fields: {[id: string]: ISearchProviderField}  = {
    WB_APPROVAL_ID:                  {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB Approval Id',        columnResourceName: 'colId',                alignment: HorizAlignment.Left},  domainOptions: {} },
    WB_BUSINESSUNIT_ID:              {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB BusinessUnit Id',    columnResourceName: 'colBusId',             alignment: HorizAlignment.Left},  domainOptions: {} },
    WB_MDSET_ID:                     {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB MDSet Id',           columnResourceName: 'colMdSetId',           alignment: HorizAlignment.Left},  domainOptions: {} },
    APPROVAL_ID:                     {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Approval Id',           columnResourceName: 'colId',                alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    APPROVAL_NAME:                   {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Approval Name',         columnResourceName: 'colApprovalName',      alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    APPROVAL_TYPE_ID:                {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Approval Type Id',      columnResourceName: 'colApprovalTypeId',    alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    APPROVAL_NOTES:                  {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Approval Notes',        columnResourceName: 'colApprovalNotes',     alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    APPROVAL_SUBSET_ID:              {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Approval Subset Id',    columnResourceName: 'colApprovalSubsetId',  alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    EVALUATION_ORDER:                {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Evaluation Order',      columnResourceName: 'colEvaluationOrder',   alignment: HorizAlignment.Left},  domainOptions: {}},
    WB_CUST_ID:                      {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB Cust Id',            columnResourceName: 'colCustId',            alignment: HorizAlignment.Left},  domainOptions: {}},
    WB_EVTTYPE_ID:                   {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB Evttype Id',         columnResourceName: 'colEvtTypId',          alignment: HorizAlignment.Left},  domainOptions: {}},
    WB_EVTSTYPE_ID:                  {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB Evtstype Id',        columnResourceName: 'colEvtSTypId',         alignment: HorizAlignment.Left},  domainOptions: {}},
    WB_PMTTYPE_ID:                   {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'WB Pmttype Id',         columnResourceName: 'colPmtTypId',          alignment: HorizAlignment.Left},  domainOptions: {}},
    USE_RANGE_IND:                   {type: SearchProviderFieldType.string,  renderOptions: { columnName: 'Use Range Ind',         columnResourceName: 'colUseRangeInd',       alignment: HorizAlignment.Left},  domainOptions: {maxLength: 50}},
    RANGE_LOWER_BOUND_AMT:           {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Lower Bound Amt',       columnResourceName: 'colLowerBoundAmt',     alignment: HorizAlignment.Left},  domainOptions: {}},
    RANGE_UPPER_BOUND_AMT:           {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Upper Bound Amt',       columnResourceName: 'colUpperBoundAmt',     alignment: HorizAlignment.Left},  domainOptions: {}},
    REVISED_THRESHOLD_FIXED_AMT:     {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Threshold Fixed Amt',   columnResourceName: 'colThreshFixedAmt',    alignment: HorizAlignment.Left},  domainOptions: {}},
    REVISED_THRESHOLD_PCNT:          {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Threshold Pcnt',        columnResourceName: 'colThreshPcnt',        alignment: HorizAlignment.Left},  domainOptions: {}},
    REQUIRED_ROLE_ID:                {type: SearchProviderFieldType.number,  renderOptions: { columnName: 'Req Role Id',           columnResourceName: 'colReqRoleId',         alignment: HorizAlignment.Left},  domainOptions: {}},
    EFFECTIVE_START_DT:              {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Effective Start Date',  columnResourceName: 'colEffectStart',       alignment: HorizAlignment.Center}, domainOptions: {}},
    EFFECTIVE_END_DT:                {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Effective End Date',    columnResourceName: 'colEffectEnd',         alignment: HorizAlignment.Center}, domainOptions: {}},
    DELETED_IND:                     {type: SearchProviderFieldType.boolean, renderOptions: { columnName: 'Deleted Ind',           columnResourceName: 'colDeletedInd',        alignment: HorizAlignment.Left}, domainOptions: {}},
    DELETED_DT:                      {type: SearchProviderFieldType.sapdate, renderOptions: { columnName: 'Deleted Date',          columnResourceName: 'colDeletedDate',       alignment: HorizAlignment.Left}, domainOptions: {}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    } };

const ApprovalSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_APPROVAL_ID',
        id_ui: 'APPROVAL_ID',
        name:  'APPROVAL_NAME'

    },

    searchProviderFields: vUI_Approval_Search_Fields,

    search(searchRequestSubset: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error)=>{
            let findRequest = SearchUtils.makeSearchRequest(searchRequestSubset,
                'vUI_Approval_Search',
                this.searchProviderFields,
                []);

            PASearch.findByRequest(findRequest)
                .then((res: any[])=> {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                });
        })
    }
};

const ApprovalSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: {ui5SourceId: "ApprovalSearchProfileByName"},

    profileFilter: [
        {profileFilterName: 'Id', searchProviderFieldId: 'APPROVAL_ID', renderOptions: {}},
        {profileFilterName: 'Name', searchProviderFieldId: 'APPROVAL_NAME', renderOptions: {}}
    ], //ISearchFields
    profileDisplayFields: [
        'APPROVAL_ID', 'APPROVAL_NAME', 'APPROVAL_TYPE_ID', 'APPROVAL_NOTES', 'APPROVAL_SUBSET_ID','CREATED_DTTS','MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ApprovalSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
};

const ApprovalSearch: ISearch = {
    searchName: "Find Approval",
    renderOptions: {ui5ResourceId: "ApprovalSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [ApprovalSearchProfileByName]
};
PAEnvironment.registerBusinessObjectSearch("ApprovalBO", "Approval", ApprovalSearch, "Approval Search")

export {ApprovalSearch}